module.exports = __webpack_public_path__ + "static/img/web_home_5.a265490.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/extensionPage/web_home_5.png
// module id = /z0l
// module chunks = 0